import type { CityConfig } from "../city-template/types";

export const carbondaleConfig: CityConfig = {
  city: "Carbondale",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "carbondale",
  route: "/cities/carbondale",
  title: "Emergency Passport Carbondale IL | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Carbondale, Illinois — as fast as 24 hours. Fast passport renewal for SIU faculty and students, Shawnee National Forest visitors, and all Jackson County residents. A+ BBB rated registered State Dept. courier serving Southern Illinois.",
  h1: "Emergency & Expedited Passport Services in Carbondale, IL",
  heroSubtitle: "SIU study abroad program to Spain and your passport's expiring? Southern Illinois Medicine international conference in 5 days? Shawnee wine trail trip to France and forgot to renew? We help Carbondale residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Jackson County and Southern Illinois.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Carbondale%20Illinois%20scenic%20cityscape%20featuring%20Southern%20Illinois%20University%20campus%20with%20Pulliam%20Hall%20clock%20tower%20and%20Thompson%20Point%2C%20historic%20downtown%20Carbondale%20Strip%20with%20unique%20shops%20and%20restaurants%2C%20tree%20lined%20streets%20in%20a%20vibrant%20college%20town%2C%20Shawnee%20National%20Forest%20rolling%20hills%20in%20the%20background%2C%20Southern%20Illinois%20autumn%20colors%2C%20golden%20hour%20warm%20light%2C%20professional%20landscape%20photography%2C%20charming%20Illinois%20college%20town%20atmosphere&width=1800&height=700&seq=carbondale-hero-001&orientation=landscape",
  heroImageAlt: "Carbondale Illinois with SIU campus and Shawnee National Forest at golden hour",
  geoPosition: "37.7273;-89.2168",
  geoPlacename: "Carbondale, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
    distance: "Approximately 5 hours 30 minutes north of Carbondale via I-57",
  },
  nearbyCitiesZips: [
    { name: "Carbondale", zips: "62901, 62902, 62903" },
    { name: "Murphysboro", zips: "62966" },
    { name: "Marion", zips: "62959" },
    { name: "Herrin", zips: "62948" },
    { name: "Carterville", zips: "62918" },
    { name: "Johnston City", zips: "62951" },
    { name: "Du Quoin", zips: "62832" },
    { name: "Pinckneyville", zips: "62274" },
    { name: "Anna", zips: "62906" },
    { name: "Harrisburg", zips: "62946" },
    { name: "Benton", zips: "62812" },
    { name: "West Frankfort", zips: "62896" },
    { name: "Mount Vernon", zips: "62864" },
    { name: "Centralia", zips: "62801" },
    { name: "Cape Girardeau, MO", zips: "63701, 63703" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — 5+ hours away but you skip the trip" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-graduation-cap-line", title: "SIU Student & Faculty Hub", desc: "Serving SIU Carbondale study abroad, research travel, and international programs" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from any UPS or FedEx in Carbondale — no Chicago drive required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Marion, IL", route: "/states/illinois" },
    { name: "Emergency passport help in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Urgent passport services in Champaign, IL", route: "/cities/champaign" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "101 W Congress Pkwy, 4th Floor, Chicago, IL 60605",
  fpcOfficeNote: "Fast Passport Center serves Carbondale, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (5 hours 30 minutes north via I-57) — without you making the trip. Carbondale residents can ship from any UPS or FedEx in Jackson County. For Southern Illinois travelers, our courier service is the only practical fast option — driving to Chicago takes an entire day.",
  fpcOfficeDistance: "Serving Carbondale, Murphysboro, Marion, Herrin, Carterville, Johnston City, Du Quoin, Pinckneyville, Anna, Harrisburg, Benton, West Frankfort, Mount Vernon, Centralia, Cape Girardeau MO, and all of Southern Illinois",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Carbondale and Southern Illinois. From the SIU Carbondale campus and the Carbondale Strip to the historic downtowns of Murphysboro and Marion, from the Shawnee National Forest communities to the southern Illinois coal country towns — we serve all of Jackson, Williamson, and surrounding counties.",
  nearbyCitiesIntro: "We serve Carbondale and all nearby communities including Murphysboro, Marion, Herrin, Carterville, Johnston City, Du Quoin, Pinckneyville, Anna, Harrisburg, Benton, West Frankfort, Mount Vernon, and Centralia. We also serve Cape Girardeau, Missouri and the entire Southern Illinois region.",
  howItWorksIntro: "Most Carbondale travelers complete everything online and ship documents overnight. No need to drive 5+ hours to Chicago — our couriers handle the Chicago Passport Agency trip for you. For Southern Illinois, this is practically the only viable fast option.",
  mistakesIntro: "Carbondale is home to SIU with thousands of students, faculty, and researchers with international travel needs — yet the nearest passport agency is 5+ hours away. Here are the most common passport mistakes in Southern Illinois.",
  testimonialsIntro: "Carbondale travelers — from SIU students heading abroad and Shawnee Forest adventurers to Southern Illinois healthcare professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Carbondale, IL? Here are the most common ones we hear from Southern Illinois travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "11+ hour round trip drive to Chicago", "Effectively impossible for most Southern Illinois residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 11-hour round trip to Chicago required", "Essential for Southern Illinois — no other fast option", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Carbondale travelers with immediate departure needs — as fast as 24 hours. Essential for Southern Illinois — the Chicago Passport Agency is 5+ hours away.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No 11-hour Chicago round trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Carbondale adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Carbondale address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Carbondale residents — including SIU international students, new citizens, and Southern Illinois families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Carbondale residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Carbondale and Southern Illinois families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Carbondale and Jackson County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Carbondale IL", description: "Urgent passport processing for Carbondale Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Carbondale IL", description: "Fast passport renewal for Carbondale Illinois residents and SIU students and faculty." },
    { name: "First-Time Passport Carbondale IL", description: "New passport application services for Carbondale Illinois residents." },
    { name: "Child Passport Carbondale IL", description: "Minor passport services for Carbondale Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Amanda C.",
      location: "Carbondale, IL",
      rating: 5,
      text: "SIU research conference in Kyoto with 7 days notice and my passport had 4 months left — Japan requires 6 months validity. Fast Passport Center got my renewal in 3 days. I shipped from the UPS on The Strip. Saved my research presentation and my department's grant. Southern Illinois academics need this service.",
      service: "Passport Renewal",
    },
    {
      name: "Tyler J.",
      location: "Carbondale, IL",
      rating: 5,
      text: "SIU study abroad to Barcelona — applied late and needed my first passport in 2 weeks. Fast Passport Center walked me through everything and I had it in 4 days. The Murphysboro post office appointment was easy. Now I'm in Spain for the semester. Lifesaver for SIU students.",
      service: "First-Time Passport",
    },
    {
      name: "Denise K.",
      location: "Marion, IL",
      rating: 5,
      text: "Family emergency in Germany — needed my passport renewed in 48 hours. Fast Passport Center had it to me in 28 hours. From Marion to Munich in 2 days. As a Southern Illinois resident, there's literally no other way to get this done. Incredible service.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "cbd-1",
      name: "Carbondale Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1301 E Main St",
      city: "Carbondale",
      state: "IL",
      zip: "62901",
      phone: "(618) 457-5102",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Carbondale, near SIU campus",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Carbondale acceptance facility. Convenient to SIU campus and downtown Carbondale. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "cbd-2",
      name: "Murphysboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "203 N 11th St",
      city: "Murphysboro",
      state: "IL",
      zip: "62966",
      phone: "(618) 687-2331",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Murphysboro, approximately 5 miles west of Carbondale",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Murphysboro and western Jackson County. Jackson County seat. Good alternative to Carbondale post office.",
      icon: "ri-mail-line",
    },
    {
      id: "cbd-3",
      name: "Jackson County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1001 Walnut St",
      city: "Murphysboro",
      state: "IL",
      zip: "62966",
      phone: "(618) 687-7300",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Murphysboro, Jackson County Courthouse",
      website: "https://www.jacksoncounty-il.gov/",
      websiteLabel: "Jackson County Circuit Clerk",
      notes: "Jackson County acceptance facility. Located in the county seat. Call ahead to confirm passport acceptance hours and availability.",
      icon: "ri-government-line",
    },
    {
      id: "cbd-4",
      name: "Marion Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 E Main St",
      city: "Marion",
      state: "IL",
      zip: "62959",
      phone: "(618) 993-2181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Marion, approximately 15 miles east of Carbondale via IL-13",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Marion and eastern Williamson County. Good option for eastern Carbondale area residents. Full passport acceptance services.",
      icon: "ri-mail-line",
    },
    {
      id: "cbd-5",
      name: "Herrin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 N Park Ave",
      city: "Herrin",
      state: "IL",
      zip: "62948",
      phone: "(618) 942-3551",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Herrin, approximately 17 miles east of Carbondale",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Herrin and Williamson County. Convenient for residents between Carbondale and Marion.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Chicago", fpc: "No — ship from Carbondale" },
    { feature: "Time Commitment", agency: "11+ hour round trip — full day lost", fpc: "Minutes — ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for S. IL", agency: "No — nearly impossible", fpc: "Yes — the only viable fast option" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "SIU Study Abroad Deadlines",
      description: "SIU Carbondale study abroad students routinely discover expired or expiring passports weeks before departure. With Chicago 5+ hours away, these students have almost no in-person emergency options. Our courier service is literally the only practical fast solution in Southern Illinois.",
    },
    {
      icon: "ri-road-map-line",
      title: "Impossible Chicago Drive",
      description: "Many Carbondale travelers assume they can 'just drive to Chicago' for an emergency appointment. At 5.5 hours each way plus downtown Chicago navigation and wait times, this is an 11+ hour ordeal — effectively impossible for most people.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule Surprise",
      description: "SIU students and Shawnee Forest international travelers often don't know that many countries require 6 months of passport validity past the return date. A passport valid for 4 months is effectively expired for most international destinations.",
    },
    {
      icon: "ri-image-line",
      title: "Photo Standards Issues",
      description: "Southern Illinois photo services may not consistently meet federal passport photo standards. The lighting, background, and sizing requirements are strict. Use a service that guarantees passport photo compliance.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form",
      description: "Using DS-82 instead of DS-11 for first-time passports (or vice versa) is the #1 cause of rejection at Carbondale and Murphysboro acceptance facilities. Our document review catches this before submission.",
    },
    {
      icon: "ri-global-line",
      title: "International Student Visa Confusion",
      description: "SIU international students often confuse passport renewal with visa renewal. Your home country passport must remain valid. Visa issues are separate from passport validity — both must be current for travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Carbondale or Jackson County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx on The Strip or near SIU campus." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with student study abroad, academic research, and family travel." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 5+ hours away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Carbondale address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Carbondale, IL?", a: "Fast Passport Center offers emergency passport processing in Carbondale, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (5 hours 30 minutes north via I-57) — without you making the trip. For Southern Illinois residents, this is essentially the only practical fast option." },
    { q: "Does Carbondale have a passport agency?", a: "No — Carbondale does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 5 hours 30 minutes north via I-57. St. Louis also has a passport agency approximately 2 hours northwest. Fast Passport Center's courier service is the most practical fast option for Southern Illinois." },
    { q: "Can SIU students and faculty use your passport services?", a: "Absolutely. Fast Passport Center serves Southern Illinois University Carbondale students, faculty, researchers, and staff. We understand study abroad deadlines, academic conference schedules, and international research travel. Our service is ideal for the academic community — no need to spend a full day driving to Chicago." },
    { q: "What airport do Carbondale travelers use for international flights?", a: "Most Carbondale travelers use St. Louis Lambert International Airport (STL) — approximately 2 hours northwest via I-64. Some also use Nashville International Airport (BNA) — approximately 3 hours southeast, or Chicago O'Hare (ORD) — approximately 5 hours 30 minutes north." },
    { q: "Do you serve Marion, Murphysboro, and Southern Illinois communities?", a: "Yes — Fast Passport Center serves all of Southern Illinois including Carbondale, Murphysboro, Marion, Herrin, Carterville, Johnston City, Du Quoin, Pinckneyville, Anna, Harrisburg, Benton, West Frankfort, Mount Vernon, and Centralia. We also serve Cape Girardeau, Missouri." },
    { q: "Can I get my child's passport expedited in Carbondale?", a: "Yes. Fast Passport Center expedites child passports in Carbondale for minors under 16. Both parents must appear or submit notarized consent. We guide Southern Illinois families through the entire DS-11 process." },
    { q: "Where can I get passport photos in Carbondale?", a: "Walgreens on The Strip, CVS on Main Street, and the UPS Store near SIU campus all offer passport photos. SIU's Student Center may also provide photo services during academic sessions. Photos must be 2x2 inches on a white background." },
    { q: "Is there really no other fast option in Southern Illinois?", a: "Honestly — no. The nearest regional passport agencies are 2+ hours (St. Louis) and 5+ hours (Chicago) away. Both require appointments booked weeks in advance for non-emergencies. For regular urgent travel in Southern Illinois, Fast Passport Center's courier service is the only practical 24–48 hour option. It's why we're so popular in this region." },
  ],
  photoLocations: [
    { name: "Walgreens — Carbondale", address: "1350 E Main St, Carbondale, IL 62901", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Carbondale", address: "715 S Illinois Ave, Carbondale, IL 62901", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Carbondale", address: "2511 W Main St, Carbondale, IL 62901", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Murphysboro", address: "6495 Country Club Rd, Murphysboro, IL 62966", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Carbondale", address: "2516 W Murphysboro Rd, Carbondale, IL 62901", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Near SIU campus and west Carbondale. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Marion", address: "1905 Rendleman St, Marion, IL 62959", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Marion and Williamson County. REAL ID processing available. Good alternative for eastern Jackson County residents.", featured: false },
  ],
  airports: [
    {
      code: "MWA",
      name: "Veterans Airport of Southern Illinois (Marion)",
      distance: "Approximately 15 minutes east of Carbondale via IL-13",
      address: "10400 Terminal Dr, Marion, IL 62959",
      note: "Regional airport with daily flights to St. Louis via Cape Air. Closest airport to Carbondale and the SIU campus. Good for connecting to international flights at St. Louis Lambert.",
      flightUrl: "https://www.veteransairport.com/",
      flightLabel: "MWA Flight Info",
      featured: true,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "Approximately 2 hours northwest via I-64",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Primary international airport for Southern Illinois. Southwest Airlines hub with domestic connections and international flights. About 2 hours from Carbondale — the closest major airport.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Flight Info",
      featured: false,
    },
    {
      code: "BNA",
      name: "Nashville International Airport",
      distance: "Approximately 3 hours southeast via I-24",
      address: "1 Terminal Dr, Nashville, TN 37214",
      note: "Major airport with Southwest hub and international flights. Good option for Carbondale travelers heading to the Southeast, Latin America, or preferring Southwest Airlines. About 3 hours from Carbondale.",
      flightUrl: "https://flynashville.com/",
      flightLabel: "BNA Flight Info",
      featured: false,
    },
  ],
};